import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import NavLink from 'garaje/pods/components/nav-link/component';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';

interface GlobalEmployeesSignature {
  Args: {
    isEmployeesOpen?: boolean;
    trackClickEvent: (trackingString: string) => void;
  };
}

export default class GlobalEmployees extends Component<GlobalEmployeesSignature> {
  @service declare globalOverviewAccess: GlobalOverviewAccessService;

  <template>
    {{#if this.globalOverviewAccess.canVisitGlobalEmployees}}
      <li>
        <NavLink
          @route="location-overview.employees"
          @current-when={{@isEmployeesOpen}}
          class="icon-mainNav-employees flex font-bold py-2"
          {{on "click" (fn @trackClickEvent "SideBar-Global-EmployeeDirectory")}}
          data-test-nav-link-employee-directory
        >
          All employees
        </NavLink>
      </li>
    {{/if}}
  </template>
}
